import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import ReceptionDataFormatter from '../Formatters/ReceptionDataFormatter';
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'id',
      label: i18n.t('pqr.ticket_number'),
      minWidth: 100,
      align: 'center',
      formatter: (row) => {
        return Formatter.strPad(row.id, 4, '0');
      },
    },
    {
      prop: 'type',
      label: i18n.t('common_words.type'),
      minWidth: 80,
      align: 'left',
      sortable: true,
    },
    {
      prop: 'clients.name',
      label: i18n.t('pqr.client'),
      minWidth: 100,
      align: 'left',
    },
    {
      prop: 'receiving_method',
      label: i18n.t('pqr.reception_data'),
      minWidth: 200,
      align: 'left',
      formatter: ReceptionDataFormatter,
      sortable: true,
    },
  ];

  const Search = { ...Tables.Search };

  return { Table, Search };
};
export default configTable;
